import axios from 'axios'
import { CRM_API_URL } from '@/constants/api'

// Релиз кассового модуля: { version, url, publishedAt }. 404 - ещё не опубликован.
function fetchCashModule () {
  return axios.get(`${CRM_API_URL}/downloads/cash-module`).then((response) => response.data.data)
}

export default { fetchCashModule }
